
import { enterpriseSearch, doLayerSearch, convert } from '@/api/enterprise'
import axios from 'axios'
export default {
    props: [],
    data() {
        return {
            searchInput: "",
            active: 0,
            placeholderTxtList: [
                '请输入位置/地址/园区信息/坐标搜索',
                '请输入企业名称',
                '请输入城市更新项目名称',
                '请输入土地整备项目名称',
                '请输入宗地号(地籍)名称',
                '请输入历史的宗地号(地籍)名称',
                '请输入拆赔项目名称',
            ]
        }
    },
    mounted() {
        this.iniInput()
    },
    methods: {
        toLeft() {
            $('#urd').css('transform', 'translateX(0px)')
        },
        toRight() {
            $('#urd').css('transform', 'translateX(-135px)')
        },
        // 获取园区
        async handleFindParks(queryString, cb) {
            // const res = await searchPark({keyword: queryString, area: ''})
            if (queryString.length > 1) {
                if (this.active == 0) {

                    // 是否是坐标格式 x,y
                    if (queryString.split(',').length == 2) {
                        let arr = queryString.split(',')
                        let lng = parseFloat(arr[0])
                        let lat = parseFloat(arr[1])
                        if (lng && lat) {
                            convert({ lng: lng, lat: lat }).then(res => {
                                queryString = `${res.data.lng},${res.data.lat}`
                                this.doGetAddress({
                                    address: '坐标搜索',
                                    value: queryString,
                                    location: queryString
                                })
                            })
                            return;
                        }
                    }


                    await axios.get(`https://restapi.amap.com/v3/assistant/inputtips?keywords=${queryString}&key=d27b5be7b1d38c445913e8b265a29525&city=深圳&citylimit=true&datatype=all`).then(res => {
                        let arr = res.data.tips.map(item => {
                            return {
                                address: item.district + item.address,
                                value: item.name,
                                location: item.location
                            }
                        });

                        if (cb) {
                            cb(arr)
                        } else {
                            this.doGetAddress({
                                address: arr[0].district + item.address,
                                value: arr[0].name,
                                location: arr[0].location
                            })
                        }

                    })
                } else if (this.active == 1) {
                    const res = await enterpriseSearch({ keyword: queryString, is_total: 1 })
                    const arr = res.data.items.map(item => {
                        return {
                            value: item.name,
                            address: item.credit_no,
                            credit_no: item.credit_no
                        }
                    })
                    if (cb) {
                        cb(arr)
                    } else {
                        this.doGetAddress({
                            address: arr[0].credit_no,
                            value: arr[0].name,
                            credit_no: arr[0].credit_no
                        })
                    }

                }
                else if (this.active == 2 || this.active == 3 || this.active == 4 || this.active == 5 || this.active == 6) {
                    let layername = ''
                    if (this.active == 2) {
                        layername = 'szcsgxlxsj1227'
                    } else if (this.active == 3) {
                        layername = 'tdzb'
                    } else if (this.active == 4) {
                        layername = 'cadastral_data'
                    } else if (this.active == 5) {
                        layername = 'lszd'
                    } else if (this.active == 6) {
                        layername = 'cpal'
                    }

                    const res = await doLayerSearch({ keyword: queryString, layer_name: layername })
                    const arr = res.data.map(item => {
                        return {
                            layer_name: layername,
                            value: item.name,
                            address: '',
                            wkt: item.wkt,
                            credit_no: ''
                        }
                    })
                    if (cb) {
                        cb(arr)
                    } else {
                        this.doGetAddress({
                            layer_name: layername,
                            value: arr[0].name,
                            address: '',
                            wkt: arr[0].wkt,
                            credit_no: ''
                        })
                    }

                }
            } else {
                cb([])
            }
        },
        async doGetAddress(item) {
            if (this.active > 1) {
                this.$emit('doLayerSearch', item)
            } else {
                this.$emit('doGetAddress', item)
            }


        },

        iniInput() {
            let that = this
            $(function () {
                //通用头部搜索切换
                $('#search-bd li').click(function () {
                    let i = $(this).index()
                    $(this).addClass('selected').siblings().removeClass('selected');
                    that.active = i
                });
            })
        }
    }
}
